import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProductCard from "../../Components/ProductCard";
import { searchProducts } from "../../api/products.api";

const useQueryParam = (key) => {
  const { search } = useLocation();
  return new URLSearchParams(search).get(key);
};

const SearchResults = () => {
  const query = useQueryParam("q");
  const [products, setProducts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    if (!query || !query.trim()) {
      setProducts([]);
      setTotalCount(0);
      return;
    }

    setLoading(true);

    searchProducts(query)
      .then((data) => {
        if (!mounted) return;

        setProducts(
          Array.isArray(data?.results) ? data.results : []
        );
        setTotalCount(typeof data?.count === "number" ? data.count : 0);
      })
      .catch(() => {
        if (!mounted) return;
        setProducts([]);
        setTotalCount(0);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [query]);



  if (!query || !query.trim()) {
    return (
      <div className="search-page">
        <p>Start typing to search products</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="search-page">
        <div className="loading-wrap">
          <div className="loader" />
          <p>Searching…</p>
        </div>
      </div>
    );
  }

  if (!loading && products.length === 0) {
    return (
      <div className="search-page">
        <p>No products found for “{query}”</p>
      </div>
    );
  }

  return (
    <div className="search-page">
      {/* Header */}
      <div className="search-header">
        <h2>
          Results for <span>“{query}”</span>
        </h2>
        <p>{totalCount} products found</p>
      </div>

      {/* Product Grid */}
      <div className="product-grid">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchResults;
